export default function (number, percent) {
    if (!percent) {
        return number;
    }

    if (Number.isNaN(+number) || Number.isNaN(+percent)) {
        return number;
    }

    return +number * (1 - +percent / 100);
}
